import React from "react";
import company1 from "../../images/company-1.png";
import company2 from "../../images/company-2.png";
import company3 from "../../images/company-3.png";

const Main = () => {
  return (
    <section
      className="project-single-page section-padding"
      style={{ height: "auto", paddingTop: "80px", paddingBottom: "100px" }}
    >
      <div className="company-intro-container">
        <div className="company-intro-wrap">
          {/* 상단: 라벨 + 서브텍스트 */}
          <div className="company-intro-header">
            <h2 className="company-intro-label">회사소개</h2>
            <p className="company-intro-sub">
              폐수처리에서 폐수관리 및 행정지원까지 엠알메탈로에서{" "}
              {window.innerWidth < 770 && window.innerWidth > 480 && <br />}{" "}
              진행해보세요.
            </p>
          </div>

          {/* 2컬럼 레이아웃 */}
          <div className="company-intro-content">
            {/* 좌측: 이미지 그리드 */}
            <div className="company-intro-left">
              <div className="company-image-grid">
                <div className="company-image-large">
                  <img src={company1} alt="회사 소개 이미지 1" />
                </div>
                <div className="company-image-small-row">
                  <div className="company-image-small">
                    <img src={company2} alt="회사 소개 이미지 2" />
                  </div>
                  <div className="company-image-small">
                    <img src={company3} alt="회사 소개 이미지 3" />
                  </div>
                </div>
              </div>
            </div>

            {/* 우측: 제목 + 본문 */}
            <div className="company-intro-right">
              <h3
                className="company-intro-title"
                style={{ fontSize: window.innerWidth < 480 ? "18px" : "" }}
              >
                <span
                  style={{
                    color: "#0B0056",
                    fontSize: window.innerWidth < 480 ? "18px" : "",
                  }}
                >
                  {" "}
                  (주)엠알메탈로
                </span>
                의 새로운 도전은 이제 시작입니다.
              </h3>
              <p className="company-intro-body">
                <strong>
                  당사는 산업폐수처리업과 폐수재활용업에서 20년이라는 다년간의{" "}
                  {window.innerWidth < 770 && window.innerWidth > 480 && <br />}
                  경험에서 얻은 자원순환기술
                </strong>
                을 바탕으로 하여, <br />
                R&D 기술부재로 인하여 사장되어 오던 도시광산의 폐자원을 전략적인
                대상금속으로 선정하고{" "}
                {window.innerWidth < 770 && window.innerWidth > 480 && <br />}
                자원추출의 전문성을 높여 오고 있습니다.
                <br />
                <br />
                또한 당사는 이러한 축적된 전문성을 기반으로{" "}
                {window.innerWidth < 770 && window.innerWidth > 480 && <br />}
                수입에만 의존하는{" "}
                {window.innerWidth < 770 && window.innerWidth > 480 && (
                  <br />
                )}{" "}
                고가의 희토류금속을 재공급하는 최신 시스템의 기술로드맵을
                구축하여 국가적인 자원금속과 에너지의 낭비를 줄이고 자원의
                효율적{" "}
                {window.innerWidth < 770 && window.innerWidth > 480 && <br />}{" "}
                이용을 극대화하는 것에 이바지하고 있으며, 고부가가치산업인
                도시광산자원 리싸이클을 주도하고 있는 전문기술기업 입니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Main;
